export enum InternalEventType {
  SESSION_START = 'session_start',
  PAGE_VIEW = 'page_view',
  PAGE_COMPLETE = 'page_complete',
  REGISTRATION_SUCCESS = 'registration_success',
  REGISTRATION_FAILED = 'registration_failed',
  LOGIN = 'login',
  VERIFICATION_SUCCESS = 'verification_success',
  VERIFICATION_FAILED = 'verification_failed',
  PLAN_CLICK = 'plan_click',
  PLAN_SELECTED = 'plan_selected',
  PAYMENT_INFO_ADDED = 'payment_info_added',
  PAYMENT_CLICK = 'payment_click',
  PURCHASE_STARTED = 'purchase_started',
  PAYMENT_SCREEN = 'payment_screen',
  // PURCHASE_FAILED = 'purchase_failed', -- from backend
  APP_CREDENTIALS_VIEW = 'app_credentials_view',

  LTP_PRICE_CLICK = 'ltp_price_click',
  LTP_PRICE_SELECTED = 'ltp_price_selected',
  LTP_PAYMENT_INFO_ADDED = 'ltp_payment_info_added',
  LTP_PAYMENT_CLICK = 'ltp_payment_click',
  LTP_PURCHASE_STARTED = 'ltp_purchase_started',
  LTP_PAYMENT_SCREEN = 'ltp_payment_screen',
  LTP_DATA_VIEW = 'ltp_data_view',
}

export enum FacebookEventType {
  LEAD = 'Lead',
  ADD_TO_WISH_LIST = 'AddToWishlist',
  ADD_TO_CART = 'AddToCart',
  ADDED_PAYMENT_INFO = 'AddPaymentInfo',
  INITIATE_CHECKOUT = 'InitiateCheckout',
}

export enum TwitterEventType {
  LEAD = 'Lead',
  ADD_TO_WISH_LIST = 'AddToWishlist',
  ADD_TO_CART = 'AddToCart',
  ADDED_PAYMENT_INFO = 'AddPaymentInfo',
  INITIATE_CHECKOUT = 'InitiateCheckout',
}

export enum TikTokEventType {
  LEAD = 'Lead',
  ADD_TO_WISH_LIST = 'AddToWishlist',
  ADD_TO_CART = 'AddToCart',
  ADDED_PAYMENT_INFO = 'AddPaymentInfo',
  INITIATE_CHECKOUT = 'InitiateCheckout',
}

export enum GoogleAdsEventType {
  LEAD = 'Lead',
  ADD_TO_WISH_LIST = 'AddToWishlist',
  ADD_TO_CART = 'AddToCart',
  ADDED_PAYMENT_INFO = 'AddPaymentInfo',
  INITIATE_CHECKOUT = 'InitiateCheckout',
}
